module.exports = __webpack_public_path__ + "static/media/mickey3_00000Old.5d2d1714.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/mickey3_00000Old.png
// module id = 201
// module chunks = 0